import { useEffect } from "react";

/** Warms the browser cache for carousel slides so each one is already
 * downloaded by the time it's shown, instead of loading on transition. */
export function usePreloadImages(urls) {
  const key = urls.filter(Boolean).join("|");

  useEffect(() => {
    if (!key) return;
    const images = key.split("|").map((src) => {
      const img = new Image();
      img.decoding = "async";
      img.src = src;
      return img;
    });
    return () => images.forEach((img) => (img.src = ""));
  }, [key]);
}
